import Vue from 'vue'
import Router from 'vue-router'
import Meta from 'vue-meta'
Vue.use(Router)
Vue.use(Meta)
export default new Router({
  // mode: 'history',
  routes: [

    {
      path: '/',
      name: 'index',
      component: () => import('../pages/index/index.vue'),
      meta: {
        keepAlive: false // 不需要缓存
      }
    },
    {
      path: '/grade',
      name: 'grade',
      component: () => import('../pages/grade/grade.vue'),
      meta: {
        keepAlive: false // 不需要缓存
      }
    },
    {
      path: '/score',
      name: 'score',
      component: () => import('../pages/score/score.vue'),
      meta: {
        keepAlive: false // 不需要缓存
      }
    },
    {
      path: '/detail',
      name: 'detail',
      component: () => import('../pages/score/detail.vue'),
      meta: {
        keepAlive: false // 不需要缓存
      }
    },
    {
      path: '/shop',
      name: 'shop',
      component: () => import('../pages/shop/list.vue'),
      meta: {
        keepAlive: false // 不需要缓存
      }
    },
    {
      path: '/shopdetail',
      name: 'shopdetail',
      component: () => import('../pages/shop/shopdetail.vue'),
      meta: {
        keepAlive: false // 不需要缓存
      }
    },
    {
      path: '/change',
      name: 'change',
      component: () => import('../pages/change/change.vue'),
      meta: {
        keepAlive: false // 不需要缓存
      }
    },
    {
      path: '/changeDetail',
      name: 'changeDetail',
      component: () => import('../pages/change/changeDetail.vue'),
      meta: {
        keepAlive: false // 不需要缓存
      }
    },
    {
      path: '/changeList',
      name: 'changeList',
      component: () => import('../pages/change/changeList.vue'),
      meta: {
        keepAlive: false // 不需要缓存
      }
    },
    {
      path: '/coupon',
      name: 'coupon',
      component: () => import('../pages/coupon/coupon.vue'),
      meta: {
        keepAlive: false // 不需要缓存
      }
    },
    {
      path: '/couponDetail',
      name: 'couponDetail',
      component: () => import('../pages/coupon/couponDetail.vue'),
      meta: {
        keepAlive: false // 不需要缓存
      }
    },
    {
      path: '/warranty',
      name: 'warranty',
      component: () => import('../pages/warranty/warranty.vue'),
      meta: {
        keepAlive: false // 不需要缓存
      }
    },
    {
      path: '/warrantyDetail',
      name: 'warrantyDetail',
      component: () => import('../pages/warranty/warrantyDetail.vue'),
      meta: {
        keepAlive: false // 不需要缓存
      }
    },
    {
      path: '/contact',
      name: 'contact',
      component: () => import('../pages/contact/contact.vue'),
      meta: {
        keepAlive: false // 不需要缓存
      }
    },
    {
      path: '/activeList',
      name: 'activeList',
      component: () => import('../pages/active/list.vue'),
      meta: {
        keepAlive: false // 不需要缓存
      }
    },
    {
      path: '/detail1',
      name: 'detail1',
      component: () => import('../pages/active/detail1.vue'),
      meta: {
        keepAlive: false // 不需要缓存
      }
    },
    {
      path: '/detail2',
      name: 'detail2',
      component: () => import('../pages/active/detail2.vue'),
      meta: {
        keepAlive: false // 不需要缓存
      }
    },
    {
      path: '/voteDetail',
      name: 'voteDetail',
      component: () => import('../pages/active/voteDetail.vue'),
      meta: {
        keepAlive: false // 不需要缓存
      }
    },
    {
      path: '/detail3',
      name: 'detail3',
      component: () => import('../pages/active/detail3.vue'),
      meta: {
        keepAlive: false // 不需要缓存
      }
    },
    {
      path: '/prizeDetail',
      name: 'prizeDetail',
      component: () => import('../pages/active/prizeDetail.vue'),
      meta: {
        keepAlive: false // 不需要缓存
      }
    },
    {
      path: '/detail4',
      name: 'detail4',
      component: () => import('../pages/active/detail4.vue'),
      meta: {
        keepAlive: true ,// 需要缓存
        isBack:false,
      }
    },
    {
      path: '/goodsDetail',
      name: 'goodsDetail',
      component: () => import('../pages/active/goodsDetail.vue'),
      meta: {
        keepAlive: false // 不需要缓存
      }
    },
    {
      path: '/detail5',
      name: 'detail5',
      component: () => import('../pages/active/detail5.vue'),
      meta: {
        keepAlive: true ,// 不需要缓存
        isBack:false,
      }
    },
    {
      path: '/map',
      name: 'map',
      component: () => import('../pages/map/map.vue'),
      meta: {
        keepAlive: false // 不需要缓存
      }
    },
    {
      path: '/lqCoupon',
      name: 'lqCoupon',
      component: () => import('../pages/coupon/lqCoupon.vue'),
      meta: {
        keepAlive: false // 不需要缓存
      }
    },
    {
      path: '/chooseStore',
      name: 'chooseStore',
      component: () => import('../pages/shop/chooseStore.vue'),
      meta: {
        keepAlive: false // 不需要缓存
      }
    }


  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js